var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7E8A93",
  d: "M9.541 1.694a1.032 1.032 0 0 1 1.457.038c.397.412.38 1.07-.035 1.463L3.59 10.203l-1.829.239.753-2.102L9.54 1.694Zm2.476-.94A2.446 2.446 0 0 0 8.57.67l-7.148 6.76a.733.733 0 0 0-.181.276l-1.2 3.346a.715.715 0 0 0 .114.682.702.702 0 0 0 .641.258L4 11.57a.703.703 0 0 0 .394-.187l7.541-7.167a2.445 2.445 0 0 0 .083-3.463Zm-4.25 9.83a.708.708 0 0 0 0 1.416h5.65a.708.708 0 0 0 0-1.416h-5.65Z"
})));
export default SvgMobileEdit;